/* eslint-disable */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

//Material UI
import Toolbar from '@mui/material/Toolbar';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';

//Custom Icons
import MapLegendIcon from '@/icons/MapLegendIcon';

//Custom components
import FormContent from '@/components/FormContent';
import { GridContainer, GridItem } from '@/ui/Grid';
import {
  CardActionButtonSave,
  CardHeading,
  CardToolbarButtonBack,
  CardToolbarMenuButton,
  CardToolbarMenuItemDelete,
} from '@/ui/Card';
import {
  FormAvatar,
  FormHeading,
  FormHeadingID,
  FormFillContent,
} from '@/ui/Form';
import SnackbarContext from '@/context/SnackbarContext/SnackbarContext';
import dataController from '@/lib/DataController';
import useFormController from '@/components/useFormController';
import { FormContentMode } from '@/components/FormContent';
import { SnackbarContextType } from '@/context/SnackbarContext/SnackbarContext';

interface IModelFormProps {
  dc: dataController;
  recordId: number;
  mode: FormContentMode;
  form: string;
}

function MapLegendForm(props: IModelFormProps) {
  const navigate = useNavigate();

  const snackbarContext = useContext(SnackbarContext) as SnackbarContextType;
  const { dc, recordId, mode, form } = props;
  const {
    record,
    validation,
    fields,
    onFieldChange,
    doUpdate,
    doDelete,
    doClose,
    pickerDataControllers,
    dataChanged,
  } = useFormController({
    mode,
    recordId: recordId,
    form,
    dc,
    onClose: close,
  });

  const handleClickBack = () => {
    if (doClose) {
      doClose()
        .then((resp) => {
          if (resp.success) {
            navigate('/admin/map_legends');
          }
        })
        .catch((result) => {
          snackbarContext.showNotification(result.error, 'error');
        });
    }
  };

  const handleUpdate = (evt: any) => {
    if (doUpdate) {
      doUpdate()
        .then((result) => {
          if (result.success) {
            const msg = 'messages.update_map_legend_success';
            snackbarContext.showNotification(msg, 'success');
          }
        })
        .catch((result) => {
          if (result.success === false && result.validationPass === false) {
            //do nothing
          } else {
            const msg = 'error.update_map_legend';
            snackbarContext.showNotification(msg, 'error');
          }
        });
    }
  };

  const handleDelete = (evt: any) => {
    if (doDelete) {
      doDelete()
        .then((result) => {
          if (result.success) {
            const msg = 'messages.delete_map_legend_success';
            snackbarContext.showNotification(msg, 'success');
            navigate('/admin/map_legends');
          }
        })
        .catch((result) => {
          const msg = 'error.delete_map_legend';
          snackbarContext.showNotification(msg, 'error');
        });
    }
  };

  const title = record.legend_ttoken
    ? (record.legend_ttoken as string)
    : undefined;

  return (
    <Card>
      <CardHeading>
        <Toolbar variant="dense" disableGutters={true}>
          <FormAvatar ariaLabel="model" icon={<MapLegendIcon />} />
          <FormHeading
            header={title}
            subheaderContent={<FormHeadingID id={recordId} />}
            dataChanged={dataChanged}
          />
          <FormFillContent />
          <CardToolbarButtonBack onClick={handleClickBack} />
          <CardToolbarMenuButton>
            <CardToolbarMenuItemDelete onClick={handleDelete} />
          </CardToolbarMenuButton>
        </Toolbar>
      </CardHeading>
      <CardContent>
        <GridContainer direction="row" spacing={3}>
          <GridItem>
            <GridContainer direction="row">
              <FormContent
                fieldNames={[
                  'id',
                  'legend_ttoken',
                  'legend_width',
                  'legend_height',
                  'legend_rule',
                  'legend_style',
                  'legend_options',
                ]}
                record={record}
                validation={validation}
                onFieldChange={onFieldChange}
                fields={fields}
                mode={mode}
                pickerDataControllers={pickerDataControllers}
                columns={3}
              />
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardContent>
      <CardActions>
        <FormFillContent />
        <CardActionButtonSave
          onClick={handleUpdate}
          variant="contained"
          disabled={!dataChanged}
        />
      </CardActions>
    </Card>
  );
}

export default MapLegendForm;
